const findElement = (_target, callback = false) => {
  const findElementFunc = (_target) => {
    const element = document.querySelector(_target);
    if (element) {
      observer.disconnect();
      if (callback) {
        callback(element);
      }
    }
  }

  const observer = new MutationObserver(function(mutationsList, observer) {
    for (let mutation of mutationsList) {
      if (mutation.type === 'childList') {
        findElementFunc(_target);
      }
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
  findElementFunc(_target);
}

document.addEventListener("DOMContentLoaded", function () {
  findElement('.menu-popup__warning', (element) => {
    console.log("Element found with callback:", element);
    element.querySelectorAll("button").forEach(button => {
      const span = document.createElement('span');
      span.textContent = "ADA";
      span.style.display = "none";
      button.append(span);
    });
  });

  findElement('.dz-hidden-input', (element) => {
    console.log("Element found with callback:", element);
    element?.setAttribute('aria-label', 'ADA')
  });

  findElement('.g-recaptcha-response', (element) => {
    console.log("Element found with callback:", element);
    element?.setAttribute('aria-label', 'ADA')
  });

  const homeAda = setInterval(() => {
    const videoImgs = document.querySelectorAll("x-slideshow video img");
    console.log(videoImgs);
    if(videoImgs.length > 0) {
      videoImgs.forEach(videoImg => {
        videoImg.setAttribute('alt', 'videoImg');
      })
    }
  }, 1000);

  setTimeout(() => {
    clearInterval(homeAda);
  }, 5000);

  if(window.location.href.includes("/products/")) {
    const productAda = setInterval(() => {
      const btns = document.querySelectorAll("button.tabs-nav__button.text-subdued");
      if(btns.length > 0) {
        btns.forEach(btn => {
          btn.removeAttribute("aria-selected");
          btn.removeAttribute("aria-controls");
          btn.removeAttribute("role");
        });
        clearInterval(productAda);
      }
    }, 1000);
  }

  const headerAda = setInterval(() => {
    const searchs = document.querySelectorAll("a.hidden.tap-area");
    if(searchs.length > 0) {
      searchs.forEach(search => {
        search.removeAttribute("aria-controls");
      })
      clearInterval(headerAda);
    }
  }, 1000);

  const productAda2 = setInterval(() => {
    const videoImgs = document.querySelectorAll(".product-gallery__media video-media video img");
    if(videoImgs.length > 0) {
      videoImgs.forEach(videoImg => {
        videoImg.setAttribute("alt", "videoImg");
      })
      clearInterval(productAda2);
    }
  }, 1000);

  const productAda3 = setInterval(() => {
    const input = document.querySelector("quantity-selector input.quantity-selector__input");
    if(input) {
      input.setAttribute("aria-label", "input");
      clearInterval(productAda3);
    }
  }, 1000);

  const productAda4 = setInterval(() => {
    const notifyLabel = document.querySelector(".notify-label-email");
    if(notifyLabel) {
      notifyLabel.setAttribute("for", "notify_email");
      clearInterval(productAda4);
    }
  }, 1000);

  const productAda5 = setInterval(() => {
    const yotpo = document.querySelector(".yotpo-main-widget-layout-reviews");
    if(yotpo) {
      yotpo.querySelector("h3.yotpo-paragraph-summary-title")?.setAttribute("aria-level", "2");
      clearInterval(productAda5);
    }
  }, 1000);
});